import accountSettings from './accountSettings.json'
import organizationSettings from './organizationSettings.json'
import settings from './settings.json'
import auth from './auth.json'
import classes from './classes.json'
import clients from './clients.json'
import common from './common.json'
import dashboard from './dashboard.json'
import equipment from './equipment.json'
import errors from './errors.json'
import facility from './facility.json'
import instructors from './instructors.json'
import navigation from './navigation.json'
import client from './client.json'
import landing from './landing.json'
import offline from './offline.json'
import notifications from './notifications.json'
import payment from './payment.json'
import pass from './pass.json'
import payments from './payments.json'
import templates from './templates.json'
import communications from './communications.json'
import home from './home.json'
import signup from './signup.json'

const plMessages = {
    accountSettings,
    organizationSettings,
    auth,
    classes,
    clients,
    common,
    dashboard,
    equipment,
    errors,
    facility,
    instructors,
    navigation,
    client,
    landing,
    offline,
    notifications,
    payment,
    pass,
    payments,
    signup,
    settings,
    templates,
    communications,
    home
} as const

export default plMessages
